import http from "@/plugin/axios";

export default {
  /**
   * 特约商户状态详情
   */
  getProviderStatus: (data: any): Promise<any> => {
    return http.post("active/wxPay/getProviderStatus", data);
  },

  /**
   * 特约商户信息
   */
  getProviderDetail: (data: any): Promise<any> => {
    return http.post("active/wxPay/getProviderDetail", data);
  },

  /**
   * 特约商户信息个数
   */
  getProviderCount: (data: any): Promise<any> => {
    return http.post("active/wxPay/getProviderCount", data);
  },

  /**
   * 申请商户
   */
  applyMch: (data: any): Promise<any> => {
    return http.post("active/wxPay/applyMch", data);
  },

  /**
   * 申请单详情
   */
  getApplyDetail: (data: any): Promise<any> => {
    return http.post("active/wxPay/getApplyDetail", data);
  },

  /**
   * 业务申请编号 查询 商户信息
   */
  getOutRequestNo: (data: any): Promise<any> => {
    return http.post("active/wxPay/getOutRequestNo", data);
  },
  /**
   * 商户银行卡信息

   */
  getBankPage: (data: any): Promise<any> => {
    return http.post("active/wxPay/getBankPage", data);
  },
  /**
   * 查询支行列表

   */
  getBranches: (data: any): Promise<any> => {
    return http.post("active/wxPay/getBranches", data);
  },
  /**
   * 获取省份-城市

   */
  getProviderCityList: (data: any): Promise<any> => {
    return http.post("active/wxPay/getProviderCityList", data);
  },
};
